<template>
	<div class="c-dashboard__wrap"
        :data-component-name="$options.name"
	>
		<TimeSheetComponent />
	</div>
</template>

<script>
	import TimeSheetComponent from "@/components/nav/TimeSheet.vue"

	export default {
		name: "Timesheet",
		components: {
			TimeSheetComponent
		},
		// props: {
		// },
		// data(){
		// },
		// methods: {
		// },
		// mounted(){
		// },
	}
</script>
